import { LineItem } from "@secureo/common/typings/Cart"
import { DeliveryOptionsByDestinationCountryCode } from "@secureo/common/typings/Product"

export const getDeliveryOptionSkusFromDeliveryOptionsByDestinationCountryCode = (
	deliveryOptionsByDestinationCountryCode: DeliveryOptionsByDestinationCountryCode,
) => {
	try {
		const skus = Object.values(deliveryOptionsByDestinationCountryCode).reduce(
			(skus, deliveryOptions) => {
				return [...skus, ...deliveryOptions.map(({ sku }) => sku)]
			},
			[],
		) as string[]

		return skus
	} catch (err) {
		console.error(err)
		return []
	}
}

const getAllDeliveryOptionSkusForLineItems = (lineItems: LineItem[]) => {
	const lineItemsWithoutConfigurations = lineItems.filter(
		({ isConfiguration }) => !isConfiguration,
	)

	const deliveryOptionSkus = Array.from(
		new Set(
			lineItemsWithoutConfigurations
				.map((lineItem) => {
					const {
						variant: { deliveryOptionsByDestinationCountryCode },
					} = lineItem

					const skus = getDeliveryOptionSkusFromDeliveryOptionsByDestinationCountryCode(
						deliveryOptionsByDestinationCountryCode,
					)

					return skus
				})
				.flat(),
		),
	)

	return deliveryOptionSkus
}

export default getAllDeliveryOptionSkusForLineItems
